import * as React from 'react';
import { useSession } from '@sdk/session/SessionContext';
import { AuthProvider } from '@sdk/authentication/AuthContext';

import { PremiumGuardProvider } from '@web/premiumGuard/PremiumGuardContext';

export type PremiumGuardBridge = {
  openPremiumGuardModal: () => void;
  openPricingModal: () => void;
  openLaborCostVideoModal: () => void;
};

type Props = {
  children: React.ReactNode;
  premiumGuardBridge: PremiumGuardBridge;
};

export const PremiumGuardAdapter = ({ children, premiumGuardBridge }: Props) => {
  const { currentUser } = useSession();

  return (
    <AuthProvider currentUser={currentUser}>
      <PremiumGuardProvider
        openPremiumGuardModal={premiumGuardBridge.openPremiumGuardModal}
        openPricingModal={premiumGuardBridge.openPricingModal}
        openLaborCostVideoModal={premiumGuardBridge.openLaborCostVideoModal}>
        {children}
      </PremiumGuardProvider>
    </AuthProvider>
  );
};
